import { post } from "../Https";

// free text initialize API endpoint
export const freeTextInitialize = (data: any) => {
  return post("/drx/api/rxpad/initalizefreetext.do", data);
};

// free text add new prescription API endpoint && freeText Add To Med History
export const freeTextAddNew = (data: any) => {
  return post("/drx/api/rxpad/freetextnext.do", data);
};

//free text print prescription API endpoint
export const freeTextPrint = (data: any) => {
  return post("/drx/api/rxpad/freetextprint.do", data);
};

//free text print and fax prescription API endpoint
export const freeTextPrintAndFax = (params: any, data: any) => {
  return post(
    "/drx/api/rxpad/medicationhistory/freetextprintandfax.do?" + params,
    data
  );
};

//free text confirm prescriptions API endpoint
export const freeTextConfirm = (data: any) => {
  return post("/drx/api/rxpad/confirm/freetext/prescription.do", data);
};
